/* eslint-disable @typescript-eslint/no-unused-vars */

export const overlapStyle = ({ palette = {} }) => ({
  '& .overlap-shadow': {
    borderLeft: '1px solid #EDEBE9',
    boxShadow: 'inset 7.2px 0px 7.2px -7.2px rgba(0, 0, 0, 0.132)',
  },
});
